import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../../Styles/InputStyles";
import { capitalizeFirstLetter } from "../../../helpers";

const ViewDetails = ({
    onClose,
    selectedData,
}) => {
    const hasLeaseDocs = (selectedData?.docs && Array.isArray(selectedData.docs) && selectedData.docs.length > 0);
    return (
        <>
            <Container>
                <Header>
                    <Title>Property Details</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>

                <ProfileSection>
                    <UserInfo>
                        <span className="font-medium mb-1 text-lg">
                            {selectedData?.name || "N/A"}
                        </span>
                        <div className="flex flex-col gap-1">
                            <span className="text-sm text-gray-600">
                                Property ID: {selectedData?.gId || "N/A"}
                            </span>

                        </div>
                    </UserInfo>
                    <Summary>
                        <SummaryItem>
                            <span className="label">Dues</span>
                            <span className="value">
                                {'₹' + (selectedData?.pendingDues || 0)}
                            </span>
                        </SummaryItem>
                    </Summary>
                </ProfileSection>

                <Content>
                    <ScrollableContent>
                        <Wrapper>
                            {/* Owner Information Section */}
                            <BtnWrapper>
                                <SectionTitle>Primary Tenant Details</SectionTitle>
                            </BtnWrapper>
                            <Section>
                                <Row>
                                    <FlexCol >
                                        <Label>Name</Label>
                                        <Value>{capitalizeFirstLetter(selectedData?.ownerName || "N/A")}</Value>
                                    </FlexCol>
                                    <FlexCol >
                                        <Label>Mobile</Label>
                                        <Value>{'#' + selectedData?.ownerMobile || "N/A"}</Value>
                                    </FlexCol>
                                </Row>
                            </Section>
                            {/* Basic Information Section */}
                            <BtnWrapper>
                                <SectionTitle>Rent & Agreement Details</SectionTitle>
                            </BtnWrapper>
                            <Section>
                                <Row>
                                    <FlexCol>
                                        <Label>Rent</Label>
                                        <Value>{'₹' + selectedData?.leaseRent}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Security</Label>
                                        <Value>{'₹' + selectedData?.leaseSecurity}</Value>
                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol>
                                        <Label>Notice</Label>
                                        <Value>{selectedData?.leaseNotice + " Month/s"}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Lock In</Label>
                                        <Value>{selectedData?.leaselockInPeriod + " Month/s"}</Value>
                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol>
                                        <Label>Rent Date</Label>
                                        <Value>{moment(selectedData?.rentDate).format("DD")}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Agmt Duration</Label>
                                        <Value>{selectedData.startDate
                                            ? moment(selectedData.startDate).format("DD, MMM YY")
                                            : "-"}
                                            {' - '}
                                            {selectedData.endDate
                                                ? moment(selectedData.endDate).format("DD, MMM YY")
                                                : "-"}</Value>
                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol>
                                        <Label>Increment Type</Label>
                                        <Value>{selectedData?.incrementType === 1 ? 'Flat Amount' : 'Percentage'}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Increment Value</Label>
                                        <Value>
                                            {selectedData?.incrementType === 1
                                                ? `₹${selectedData?.incrementValue}`
                                                : `${selectedData?.incrementValue}%`}
                                        </Value>

                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol>
                                        <Label>Increment After</Label>
                                        <Value>{selectedData?.incrementMonth + " Month/s"}</Value>
                                    </FlexCol>
                                    <FlexCol>
                                        <Label>Created Date</Label>
                                        <Value>{moment(selectedData?.createdAt).format("DD, MMM YYYY")}</Value>
                                    </FlexCol>
                                </Row>
                            </Section>

                            {/* Address Section */}
                            <BtnWrapper>
                                <SectionTitle>Address</SectionTitle>
                            </BtnWrapper>
                            <Section>
                                <Row>
                                    <FlexCol className="col-span-2">
                                        <Label>Street Address</Label>
                                        <Value>{selectedData?.streetAddress || "N/A"}</Value>
                                    </FlexCol>
                                </Row>
                                <Row>
                                    <FlexCol className="col-span-2">
                                        <Label>Full Address</Label>
                                        <Value>{selectedData?.address || "N/A"}</Value>
                                    </FlexCol>
                                </Row>
                            </Section>
                            <BtnWrapper>
                                <SectionTitle>Documment</SectionTitle>
                            </BtnWrapper>
                            <Section>
                                {hasLeaseDocs ? (
                                    <div >
                                        {(selectedData.docs).map((doc, index) => (
                                            <div
                                                key={index}
                                                className="flex items-center justify-between p-2"
                                            >
                                                <span className="text-gray-700">
                                                    {doc.title || `Document ${index + 1}`}
                                                </span>
                                                <a
                                                    href={doc.value}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-500 underline text-sm"
                                                >
                                                    View
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center py-4">
                                        <p className="text-gray-500">No documents uploaded</p>
                                    </div>
                                )}
                            </Section>
                        </Wrapper>
                    </ScrollableContent>
                </Content>
            </Container>
        </>
    );
};

const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-4 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 gap-4 py-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-sm md:text-base`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center justify-between bg-gray-100 px-4 p-4`;
const Summary = tw.div`flex gap-6`;

const SummaryItem = tw.div`
  flex flex-col text-right
  .label { @apply text-xs text-gray-500; }
  .value { @apply text-lg font-semibold; }
`;

export default ViewDetails;